import React, { lazy, Suspense } from 'react';

const LazyInvoicesPage = lazy(() => import('./InvoicesPage'));

const InvoicesPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyInvoicesPage {...props} />
  </Suspense>
);

export default InvoicesPage;
